import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@bos/ui';
import { useController } from 'react-hook-form';
export const SelectField = ({ control, name, registerOptions, onOpenChange, ...selectInputProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        ...registerOptions,
    });
    const handleOpenChange = (open) => {
        onOpenChange?.(open);
        if (!open) {
            field.onBlur();
        }
    };
    const handleValueChange = (value) => field.onChange(value);
    const currentValue = field.value ?? '';
    return (_jsx(Select, { ...selectInputProps, value: currentValue, error: fieldState.error?.message, withIndicator: true, onOpenChange: handleOpenChange, onValueChange: handleValueChange }));
};
